<template>
    <PopupRouterViewDetail label="Di Subcont Delivery Card Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Delivery Card" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Delivery Card Number" :model="model.deliveryCardNumber" />
						<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Part" id="fieldset-part" size="sm" :model.sync="model.partId" :isRequired="true" :state="validateState('partId')" :errorMessage="getErrorMessage(errorMessage.partId, 'partId')"   :selected="model.part != null ? model.part.partNumber : ''" @input="getParts" @change="updateData" :isEditable="false" :isUpdatable="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedPart" />
						<app-input-textbox id="fieldset-dc-qty" label-cols-lg="12"  label="DC Qty" label-for="input-dc-qty" size="sm" :model.sync="model.dcQty" :isRequired="true" :state="validateState('dcQty')" :errorMessage="getErrorMessage(errorMessage.dcQty, 'dcQty')"  @change="updateData" :isEditable="false" :isUpdatable="false"/>
						<app-input-combobox-autocomplete :options="deliveryInstructionSubcontractDetails" optionsLabel="part" optionsKey="id" label-cols-lg="12" label="DI Subcont Detail" id="fieldset-delivery-instruction-subcontract-detail" size="sm" :model.sync="model.deliveryInstructionSubcontractDetailId" :isRequired="true" :state="validateState('deliveryInstructionSubcontractDetailId')" :errorMessage="getErrorMessage(errorMessage.deliveryInstructionSubcontractDetailId, 'deliveryInstructionSubcontractDetailId')"   :selected="model.deliveryInstructionSubcontractDetail != null ? model.deliveryInstructionSubcontractDetail.part : ''" @input="getDeliveryInstructionSubcontractDetails" @change="updateData" :isEditable="false" :isUpdatable="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedDeliveryInstructionSubcontractDetail" />
						<app-input-datetimepicker id="fieldset-delivery-date" label-cols-lg="12"  label="Delivery Date" size="sm" :model.sync="model.deliveryDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" :isEditable="false" :isUpdatable="false"/>
						<app-input-textbox id="fieldset-sequence" label-cols-lg="12"  label="Sequence" label-for="input-sequence" size="sm" type="number" :model.sync="model.sequence"  @change="updateData" :isEditable="false" :isUpdatable="false"/>
						<app-input-textbox id="fieldset-total-delivery-card" label-cols-lg="12"  label="Total DeliveryCard" label-for="input-total-delivery-card" size="sm" type="number" :model.sync="model.totalDeliveryCard"  @change="updateData" :isEditable="false" :isUpdatable="false"/>
						<app-input-textbox id="fieldset-transaction-type" label-cols-lg="12"  label="Transaction Type" label-for="input-transaction-type" size="sm" :model.sync="model.transactionType"  @change="updateData" :isEditable="false" :isUpdatable="false"/>
						<app-input-textbox id="fieldset-transaction-id" label-cols-lg="12"  label="Transaction Id" label-for="input-transaction-id" size="sm" type="number" :model.sync="model.transactionId"  @change="updateData" :isEditable="false" :isUpdatable="false"/>
						<app-input-checkbox id="fieldset-is-is-used" label-cols-lg="12" label="Is Used" label-for="input-is-is-used" size="sm" :model.sync="model.isUsed" :isEditable="false" :isUpdatable="false"checkedValue="Yes" uncheckedValue="No" @change="updateData" />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import DiSubcontDeliveryCard from '@/models/DiSubcontDeliveryCard/DiSubcontDeliveryCard';
import DiSubcontDeliveryCardList from '@/models/DiSubcontDeliveryCard/DiSubcontDeliveryCardList';
import DiSubcontDeliveryCardFilter from '@/filters/DiSubcontDeliveryCard/DiSubcontDeliveryCardFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import DeliveryInstructionSubcontractDetail from '@/models/DeliveryInstructionSubcontract/DeliveryInstructionSubcontractDetail';
import DeliveryInstructionSubcontractDetailFilter from '@/filters/DeliveryInstructionSubcontract/DeliveryInstructionSubcontractDetailFilter';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import AppInputCheckbox from '@/components/AppInputCheckbox';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputCheckbox,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			partId: {required},
			dcQty: {required},
			deliveryInstructionSubcontractDetailId: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				partId: { required : "Part is Required."},
				dcQty: { required : "DC Qty is Required."},
				deliveryInstructionSubcontractDetailId: { required : "DI Subcont Detail is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterDiSubcontDeliveryCard : null,
			currentDiSubcontDeliveryCardPage : 1,
			diSubcontDeliveryCardPageSize: 10,
			sortByDiSubcontDeliveryCard: '',
			sortDescDiSubcontDeliveryCard: '',
			parts: [],
			parts: [],
			isPartComboLoading: false,
			deliveryInstructionSubcontractDetails: [],
			deliveryInstructionSubcontractDetails: [],
			isDeliveryInstructionSubcontractDetailComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isPartComboLoading: false,
			isDeliveryInstructionSubcontractDetailComboLoading: false,
		}
	},
	methods : {
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getDiSubcontDeliveryCard : async function(id) {
			this.isBusy = true;
			DiSubcontDeliveryCard.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadDiSubcontDeliveryCard = true;
			this.filterDiSubcontDeliveryCard.id = this.modelId;
			DiSubcontDeliveryCard.downloadDataDetail(this, this.filterDiSubcontDeliveryCard).then(result => {
				this.isDownloadDiSubcontDeliveryCard = false;
			}).catch(error => { this.isDownloadDiSubcontDeliveryCard = false; })
		},
		getDiSubcontDeliveryCards : async function(input) {
			let filter = new DiSubcontDeliveryCardFilter();
			if (input != undefined) {
				filter.DeliveryCardNumber = input;
			}
			this.isDiSubcontDeliveryCardComboLoading = true;
			DiSubcontDeliveryCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.diSubcontDeliveryCards = result.data
				}
				this.isDiSubcontDeliveryCardComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPart(item) {
			if(item == undefined || item == null) {
				this.model.partId = null;
				this.model.part = null;
			} else {
				this.model.partId = item.id;
				this.model.part = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getDeliveryInstructionSubcontractDetails : async function(input) {
			let filter = new DeliveryInstructionSubcontractDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			DeliveryInstructionSubcontractDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructionSubcontractDetails = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedDeliveryInstructionSubcontractDetail(item) {
			if(item == undefined || item == null) {
				this.model.deliveryInstructionSubcontractDetailId = null;
				this.model.deliveryInstructionSubcontractDetail = null;
			} else {
				this.model.deliveryInstructionSubcontractDetailId = item.id;
				this.model.deliveryInstructionSubcontractDetail = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.diSubcontDeliveryCardInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						DiSubcontDeliveryCard.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'disubcontdeliverycardindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						DiSubcontDeliveryCard.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'disubcontdeliverycardindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					DiSubcontDeliveryCard.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getDiSubcontDeliveryCard(id);
					});
				}
			});
		},
		onHidden() {
			this.getDiSubcontDeliveryCards();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterDiSubcontDeliveryCard = new DiSubcontDeliveryCardFilter();
		//this.getParts();
		//this.getDeliveryInstructionSubcontractDetails();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getDiSubcontDeliveryCard(id);
			} else {
				this.modelId = id;
				this.getDiSubcontDeliveryCard(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
